import React from 'react';
import MissionControlDashboard from '../../../components/admin/missionControl/MissionControlDashboard';

const MissionControlScreen = () => {
  return <MissionControlDashboard />;
};

export default MissionControlScreen;
